import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SportsThemedTabsDirective } from '@frontend/sports/common/ui/sports-themed-tab-group';
import { DsDivider } from '@frontend/ui/divider';
import { DsTabsModule } from '@frontend/ui/tabsgroup';
import { EffectsModule } from '@ngrx/effects';

import BetslipDigitalComboBetModule from '../combo-bet/betslip-digital-combo-bet.module';
import BetslipDigitalPicksModule from '../picks/betslip-digital-picks.module';
import BetslipDigitalSingleBetModule from '../single-bet/betslip-digital-single-bet.module';
import BetslipDigitalSystemBetModule from '../system-bet/betslip-digital-system-bet.module';
import { BetslipDigitalTeaserModule } from '../teaser-bet/digital-module';
import BetslipTypesModule from './betslip-types.module';
import BetslipTypeTabsComponent from './components/digital/betslip-type-tabs/betslip-type-tabs.component';
import DigitalTabsSelectionEffects from './effects/digital-tabs-selection-effects';
import LinearTypeEffects from './effects/linear-type-effects';
import PickTypeEffects from './effects/pick-type-effects';
import { PickTypeSharedEffects } from './effects/pick-type-shared.effects';

@NgModule({
    imports: [
        CommonModule,
        BetslipTypesModule,
        BetslipDigitalPicksModule,
        EffectsModule.forFeature([PickTypeEffects, DigitalTabsSelectionEffects, LinearTypeEffects, PickTypeSharedEffects]),
        BetslipDigitalSingleBetModule,
        BetslipDigitalComboBetModule,
        BetslipDigitalSystemBetModule,
        BetslipDigitalTeaserModule,
        DsTabsModule,
        SportsThemedTabsDirective,
        DsDivider,
    ],
    declarations: [BetslipTypeTabsComponent],
    exports: [BetslipTypeTabsComponent],
})
export default class BetslipDigitalTypesModule {}
